module.exports = __webpack_public_path__ + "static/media/traffic-light-stop.ba4a769b.svg";